module.exports = __webpack_public_path__ + "img/fdsg3.509a661d.png";